module.exports = __webpack_public_path__ + "images/help/avatars/gaoyu-e56ae6116848f765cd006cda4dce4aa3.jpg";